export default __webpack_public_path__ + "static/media/keety.aa8ccb71.png";